import React from 'react'

export default function RoamingCountriesList() {
    const styles ={
        icon:{
            width: '42px',
            borderRadius: '4px'
        },
        rigthArrow:{
            width: '16px',
            height: '16px',
            marginRight: '-5px'
        }
    }
  return (
    <div className="tab-content">
    <div
      role="tabpanel"
      id="uncontrolled-tab-example-tabpane-All"
      aria-labelledby="uncontrolled-tab-example-tab-All"
      className="fade tab-pane active show"
    >
      <div className="">
        <div className="">
          <h6 className="pt-4 pb-3 "><div  className="shimmerBG mb-0 w-50 shimmer-h25"></div></h6>
          {[1,2,3,4].map(item => <div className="card_style_5 mb-3 sprint14_card_style_5">
            <div className="card_style_5_header flex_grp_align_center">
              <div className="card_img ">
                <div className=" count-img shimmerBG mb-0 shimmer-h25" style={styles.icon}></div>
              </div>
              <div className="card_info flex1">
                <p className="shimmerBG w-50 shimmer-h20"></p>
              </div>
              <div className="hyperlink">
                <div
                  
                  
                  style={styles.rigthArrow}
                  className="shimmerBG mb-0 shimmer-img-xs"
                />
                {/* <div className="shimmerBG shimmer-img-xs">ekrjfsd</div> */}
              </div>
            </div>
          </div>)}
        </div>
        <div className="">
          <h6 className="pt-4 pb-3 "><div  className="shimmerBG mb-0 w-50 shimmer-h25"></div></h6>
          {[1,2,3,4,5,6,7,8,9,10].map(item => <div className="card_style_5 mb-3 sprint14_card_style_5">
            <div className="card_style_5_header flex_grp_align_center">
              <div className="card_img ">
                <div className=" count-img shimmerBG mb-0 shimmer-h25" style={styles.icon}></div>
              </div>
              <div className="card_info flex1">
                <p className="shimmerBG w-50 shimmer-h20"></p>
              </div>
              <div className="hyperlink">
                <div
                  
                  
                  style={styles.rigthArrow}
                  className="shimmerBG mb-0 shimmer-img-xs"
                />
                {/* <div className="shimmerBG shimmer-img-xs">ekrjfsd</div> */}
              </div>
            </div>
          </div>)}
          
          
        </div>
      </div>
    </div>
  </div>
  )
}
